export const LoadShortTime = (timeStampString) =>{
    if(!timeStampString) return 'invalid';
    let timeStamp;
    if (/^\d+$/.test(timeStampString)) timeStamp = new Date(Number(timeStampString));
    else timeStamp = new Date(timeStampString);
    if(isNaN(timeStamp)){
        const timePart = timeStampString.split('.')[0];
        const today = new Date();
        const todayString = today.toISOString().split('T')[0];
        const combined = `${todayString}T${timePart}`;
        timeStamp = new Date(combined);
    }
    if(isNaN(timeStamp)) return 'invalid';
    const hours = timeStamp.getHours();
    const minutes = timeStamp.getMinutes();
    const seconds = timeStamp.getSeconds();
    return `${hours >= 10? '':'0'}${hours}:${minutes >= 10? '':'0'}${minutes}:${seconds >= 10? '':'0'}${seconds}`;
}